import React, { useEffect, useState } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "../ag-table.css";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";
import ModalComp from "../themes/Model";
import api from "../axiosConfig";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import { getUser } from "../helpers";

const AddNewProductModal = ({
  isModalOpen,
  setIsModalOpen,
  shouldDisableDate,
  qtyLabel = "Qty",
  warehouseMulti = true,
  channelMulti = true,
  priceListMulti = true,
  modalTitle,
}) => {
  const [selectedWarehouse, setSelectedWarehouse] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [channels, setChannels] = useState([]);
  const [categories, setCategories] = useState([]);
  const [productNames, setProductNames] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [modalformData, modalsetFormData] = useState({
    warehouse: [],
    channel: [],
    pricelist: [],
    product: "",
    schemeStartDate: null,
    schemeEndDate: null,
    MRP: "",
    PTR: "",
    Qty: "",
  });
  const [errors, setErrors] = useState({});
  const user = getUser();

  const resetForm = () => {
    modalsetFormData({
      warehouse: null,
      channel: [],
      pricelist: [],
      product: "",
      schemeStartDate: null,
      schemeEndDate: null,
      MRP: "",
      PTR: "",
      Qty: "",
    });
  };

  const validateForm = () => {
    const newErrors = {};

    // Check if warehouse array is empty
    if (modalformData.warehouse.length === 0)
      newErrors.warehouse = "Warehouse is required";
    if (modalformData.channel.length === 0)
      newErrors.channel = "Channel is required";
    if (modalformData.pricelist.length === 0)
      newErrors.pricelist = "Price list is required";
    if (!modalformData.product) newErrors.product = "Product is required";

    if (!modalformData.schemeStartDate)
      newErrors.schemeStartDate = "Start date is required";
    if (!modalformData.schemeEndDate)
      newErrors.schemeEndDate = "End date is required";
    if (modalformData.schemeStartDate && modalformData.schemeEndDate) {
      const start = dayjs(modalformData.schemeStartDate);
      const end = dayjs(modalformData.schemeEndDate);
      if (end.isBefore(start))
        newErrors.schemeEndDate = "End date cannot be before start date";
    }

    if (!modalformData.MRP) newErrors.MRP = "MRP is required";
    else if (isNaN(modalformData.MRP)) newErrors.MRP = "MRP must be a number";

    if (!modalformData.PTR) newErrors.PTR = "PTR is required";
    else if (isNaN(modalformData.PTR)) newErrors.PTR = "PTR must be a number";

    if (!modalformData.Qty) newErrors.Qty = "Quantity is required";
    else if (isNaN(modalformData.Qty))
      newErrors.Qty = "Quantity must be a number";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const clearFormFields = () => {
    modalsetFormData({
      warehouse: "",
      channel: "",
      pricelist: "",
      product: "",
      startdate: "",
      enddate: "",
      mrp: "",
      ptr: "",
      qty: "",
    });
  };

  const handleSave = () => {
    if (validateForm()) {
      api
        .post("/api/newproduct", {
          body: {
            ...modalformData,
            user,
            page: "dayleveledit",
            productCode: modalformData.productCode,
          },
        })
        .then((response) => {
          clearFormFields();
          handleClose();
        })
        .catch((error) => {
          console.error("Error saving product:", error);
        });
    }
  };

  useEffect(() => {
    api
      .get("/warehouses")
      .then((response) => setWarehouses(response.data || []))
      .catch((error) => console.error("Error fetching warehouses:", error));

    api
      .get("/channels")
      .then((response) => setChannels(response.data || []))
      .catch((error) => console.error("Error fetching channels:", error));

    api
      .get("/pricelist")
      .then((response) => setCategories(response.data || []))
      .catch((error) => console.error("Error fetching categories:", error));

    api
      .get("/productswithname")
      .then((response) => setProductNames(response.data || []))
      .catch((error) => console.error("Error fetching productNames:", error));
      console.log(productNames, "response.data product name ");
  }, []);

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleWarehouseChange = (event, newValue) => {
    if (warehouseMulti) {
      // Multi-Select Logic
      if (newValue.some((item) => item.Warehouse === "Select All")) {
        // Toggle Select All
        const allSelected = selectedWarehouse.length === warehouses.length;
        const updatedSelection = allSelected
          ? []
          : warehouses.map((w) => w.Warehouse);

        setSelectedWarehouse(updatedSelection);

        // Update form data
        modalsetFormData((prevData) => ({
          ...prevData,
          warehouse: updatedSelection, // Update warehouse field in form data
        }));

        // No error if all selected, or none selected (empty selection)
        setErrors((prevErrors) => ({
          ...prevErrors,
          warehouse:
            updatedSelection.length > 0 ? null : "This field is required",
        }));
      } else {
        // Handle normal selection
        const selectedValues = newValue.map((item) => item.Warehouse);
        setSelectedWarehouse(selectedValues);

        modalsetFormData((prevData) => ({
          ...prevData,
          warehouse: selectedValues, // Update warehouse field in form data
        }));

        // Set error if selection is empty
        setErrors((prevErrors) => ({
          ...prevErrors,
          warehouse: selectedValues.length ? null : "This field is required",
        }));
      }
    } else {
      // Single-Select Logic
      const selectedValue = newValue ? newValue.Warehouse : ""; // Extract single value
      setSelectedWarehouse([selectedValue]); // Store as an array for consistency

      modalsetFormData((prevData) => ({
        ...prevData,
        warehouse: selectedValue, // Update warehouse field in form data
      }));

      // Set error if selection is empty
      setErrors((prevErrors) => ({
        ...prevErrors,
        warehouse: selectedValue ? null : "This field is required",
      }));
    }
  };

  const handleProductChange = (event, newValue) => {
    const selectedProduct = productNames.find(
      (product) => product.Product_Name === newValue
    );

    setSelectedProduct(selectedProduct ? selectedProduct.Product_Name : "");
    modalsetFormData((prevData) => ({
      ...prevData,
      product: selectedProduct ? selectedProduct.Product_Name : "",
      productCode: selectedProduct ? selectedProduct.ProductCode : null,
    }));
  };

  const handleChannelChange = async (event, newValue) => {
    if (channelMulti) {
      // Multi-Select Logic
      const newSelectedChannels = Array.isArray(newValue)
        ? newValue.map((item) => item.Channel)
        : [];

      if (newSelectedChannels.includes("Select All")) {
        const allSelected = selectedChannel.length === channels.length;
        const allChannels = allSelected ? [] : channels.map((c) => c.Channel);
        setSelectedChannel(allChannels);

        modalsetFormData((prevData) => ({
          ...prevData,
          channel: allChannels,
        }));

        setErrors((prevErrors) => ({
          ...prevErrors,
          channel: allChannels.length ? null : "Please select a channel",
        }));
      } else {
        setSelectedChannel(newSelectedChannels);

        modalsetFormData((prevData) => ({
          ...prevData,
          channel: newSelectedChannels,
        }));

        setErrors((prevErrors) => ({
          ...prevErrors,
          channel: newSelectedChannels.length
            ? null
            : "Please select a channel",
        }));
      }
    } else {
      // Single-Select Logic
      const selectedValue = newValue ? newValue.Channel : ""; // Extract single value
      setSelectedChannel([selectedValue]); // Store as an array for consistency

      modalsetFormData((prevData) => ({
        ...prevData,
        channel: selectedValue,
      }));

      // Set error if selection is empty
      setErrors((prevErrors) => ({
        ...prevErrors,
        channel: selectedValue ? null : "This field is required",
      }));
    }

    try {
      const response = await api.post("/pricelist", {
        body: {
          channel: warehouseMulti
            ? selectedChannel.join(",") // For multi-select, join values
            : selectedChannel[0], // For single-select, use the first value
        },
      });
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching pricelist:", error);
    }
  };

  const handleCategoryChange = (event, newValue) => {
    if (priceListMulti) {
      // Multi-Select Logic
      const newSelectedCategories = Array.isArray(newValue)
        ? newValue.map((item) => item.Pricelist)
        : [];

      if (newSelectedCategories.includes("Select All")) {
        const allSelected = selectedCategory.length === categories.length;
        const allCategories = allSelected
          ? []
          : categories.map((c) => c.Pricelist);
        setSelectedCategory(allCategories);

        modalsetFormData((prevData) => ({
          ...prevData,
          pricelist: allCategories,
        }));

        setErrors((prevErrors) => ({
          ...prevErrors,
          pricelist: allCategories.length ? null : "Please select a pricelist",
        }));
      } else {
        setSelectedCategory(newSelectedCategories);

        modalsetFormData((prevData) => ({
          ...prevData,
          pricelist: newSelectedCategories,
        }));

        setErrors((prevErrors) => ({
          ...prevErrors,
          pricelist: newSelectedCategories.length
            ? null
            : "Please select a pricelist",
        }));
      }
    } else {
      // Single-Select Logic
      const selectedValue = newValue ? newValue.Pricelist : ""; // Extract single value
      setSelectedCategory([selectedValue]); // Store as an array for consistency

      modalsetFormData((prevData) => ({
        ...prevData,
        pricelist: selectedValue,
      }));

      // Set error if selection is empty
      setErrors((prevErrors) => ({
        ...prevErrors,
        pricelist: selectedValue ? null : "This field is required",
      }));
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;

  const disableDateCondition = (date) => {
    const today = dayjs().startOf("day");
    const tomorrow = today.add(1, "day");
    const startDate = modalformData.schemeStartDate
      ? dayjs(modalformData.schemeStartDate)
      : dayjs().startOf("day");
    return (
      date.isSame(today, "day") ||
      date.isSame(tomorrow, "day") ||
      date.isBefore(startDate, "day")
    );
  };

  const modalContent = (
    <>
      <div>
        <Box
          sx={{
            bgcolor: "background.paper",
            maxWidth: 800,
            maxHeight: "80vh",
            overflowY: "auto",
            mx: "auto",
          }}
        >
          <Box>
            <Grid container spacing={2}>
              {/* warehouse */}
              <Grid item xs={6} sx={{ marginTop: "5px" }}>
                <FormControl
                  variant="outlined"
                  error={!!errors.warehouse}
                  sx={{
                    minWidth: 200,
                    width: "100%",
                    height: "50%",
                    flexGrow: 1,
                    border: "1px solid white",
                    color: "white",
                  }}
                >
                  <Autocomplete
                    multiple={warehouseMulti}
                    disableCloseOnSelect={warehouseMulti}
                    options={
                      warehouseMulti
                        ? [{ Warehouse: "Select All" }, ...warehouses]
                        : warehouses
                    }
                    getOptionLabel={(option) => option.Warehouse}
                    // value={selectedWarehouse.map((warehouse) =>
                    //   warehouses.find((w) => w.Warehouse === warehouse)
                    // )}
                    value={
                      warehouseMulti
                        ? selectedWarehouse.map((warehouse) =>
                            warehouses.find((w) => w.Warehouse === warehouse)
                          )
                        : selectedWarehouse.length > 0
                        ? warehouses.find(
                            (w) => w.Warehouse === selectedWarehouse[0]
                          ) || null
                        : null
                    }
                    onChange={handleWarehouseChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Warehouse"
                        placeholder="Search..."
                        error={!!errors.warehouse}
                      />
                    )}
                    // renderTags={(selected, getTagProps) => [
                    //   ...selected
                    //     .slice(0, 2)
                    //     .map((option, index) => (
                    //       <Chip
                    //         key={option.Warehouse}
                    //         label={option.Warehouse}
                    //         {...getTagProps({ index })}
                    //       />
                    //     )),
                    //   selected.length > 2 ? (
                    //     <Chip
                    //       key="more"
                    //       label={`+${selected.length - 2} more`}
                    //       sx={{ backgroundColor: "#28B7A6", color: "white" }}
                    //     />
                    //   ) : null,
                    // ]}

                    renderTags={
                      (selected, getTagProps) =>
                        warehouseMulti
                          ? [
                              ...selected
                                .slice(0, 2)
                                .map((option, index) => (
                                  <Chip
                                    key={option.Warehouse}
                                    label={option.Warehouse}
                                    {...getTagProps({ index })}
                                  />
                                )),
                              selected.length > 2 ? (
                                <Chip
                                  key="more"
                                  label={`+${selected.length - 2} more`}
                                  sx={{
                                    backgroundColor: "#28B7A6",
                                    color: "white",
                                  }}
                                />
                              ) : null,
                            ]
                          : null // No tags for single select
                    }
                    // renderOption={(props, option, { selected }) => (
                    //   <li {...props}>
                    //     <Checkbox
                    //       icon={icon}
                    //       checkedIcon={checkedIcon}
                    //       checked={
                    //         option.Warehouse === "Select All"
                    //           ? selectedWarehouse.length === warehouses.length
                    //           : selected
                    //       }
                    //       sx={{
                    //         color: "#149485",
                    //         "&.Mui-checked": {
                    //           color: "#149485",
                    //         },
                    //       }}
                    //     />
                    //     {option.Warehouse}
                    //   </li>
                    // )}

                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        {warehouseMulti && (
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            checked={
                              option.Warehouse === "Select All"
                                ? selectedWarehouse.length === warehouses.length
                                : selected
                            }
                            sx={{
                              color: "#149485",
                              "&.Mui-checked": {
                                color: "#149485",
                              },
                            }}
                          />
                        )}
                        {option.Warehouse}
                      </li>
                    )}
                    sx={{
                      "& .MuiAutocomplete-tag": {
                        backgroundColor: "#28B7A6",
                        color: "white",
                      },
                      "& .MuiInputBase-input": {
                        color: "black",
                        backgroundColor: "white",
                      },
                    }}
                  />
                  {errors.warehouse && (
                    <FormHelperText
                      sx={{
                        color: "#FF0000 !important",
                        marginTop: "4px !important",
                        marginLeft: "0",
                        marginRight: "0",
                      }}
                    >
                      {errors.warehouse}*
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              {/* channel */}
              <Grid item xs={6} sx={{ marginTop: "5px" }}>
                <FormControl
                  variant="outlined"
                  error={!!errors.channel}
                  style={{ width: "100%", flexGrow: 1 }}
                >
                  <Autocomplete
                    multiple={channelMulti}
                    disableCloseOnSelect={channelMulti}
                    options={
                      channelMulti
                        ? [{ Channel: "Select All" }, ...channels]
                        : channels
                    }
                    getOptionLabel={(option) => option.Channel}
                    // value={selectedChannel.map((channel) =>
                    //   channels.find((c) => c.Channel === channel)
                    // )}
                    value={
                      channelMulti
                        ? selectedChannel.map((channel) =>
                            channels.find((c) => c.Channel === channel)
                          )
                        : channels.find(
                            (c) => c.Channel === selectedChannel[0]
                          ) || null
                    }
                    onChange={handleChannelChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Channel"
                        placeholder="Search..."
                        fullWidth
                        error={!!errors.channel}
                      />
                    )}
                    renderTags={
                      channelMulti
                        ? (selected, getTagProps) => [
                            ...selected
                              .slice(0, 2)
                              .map((option, index) => (
                                <Chip
                                  key={option.Channel}
                                  label={option.Channel}
                                  {...getTagProps({ index })}
                                />
                              )),
                            selected.length > 2 ? (
                              <Chip
                                key="more"
                                label={`+${selected.length - 2} more`}
                                sx={{
                                  backgroundColor: "#28B7A6",
                                  color: "white",
                                }}
                              />
                            ) : null,
                          ]
                        : null // No tags for single-select
                    }
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        {channelMulti && (
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            checked={
                              option.Channel === "Select All"
                                ? selectedChannel.length === channels.length
                                : selected
                            }
                            sx={{
                              color: "#149485",
                              "&.Mui-checked": {
                                color: "#149485",
                              },
                            }}
                          />
                        )}
                        {option.Channel}
                      </li>
                    )}
                    sx={{
                      "& .MuiAutocomplete-tag": {
                        backgroundColor: "#28B7A6",
                        color: "white",
                      },
                    }}
                  />
                  {errors.channel && (
                    <FormHelperText
                      sx={{
                        color: "#FF0000 !important",
                        marginTop: "4px !important",
                        marginLeft: "0",
                        marginRight: "0",
                      }}
                    >
                      {errors.channel}*
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
               {/* priceList & product */}
              <Grid item xs={6} sx={{ display: "flex", gap: "20px" }}>
                <FormControl
                  variant="outlined"
                  error={!!errors.pricelist}
                  style={{ minWidth: "380px", width: "100%", flexGrow: 1 }}
                >
                  <Autocomplete
                    multiple={priceListMulti}
                    disableCloseOnSelect={priceListMulti}
                    // options={[{ Pricelist: "Select All" }, ...categories]}
                    options={
                      priceListMulti
                        ? [{ Pricelist: "Select All" }, ...categories]
                        : categories
                    }
                    getOptionLabel={(option) => option.Pricelist}
                    // value={selectedCategory.map((category) =>
                    //   categories.find((c) => c.Pricelist === category)
                    // )}
                    value={
                      priceListMulti
                        ? selectedCategory.map((category) =>
                            categories.find((c) => c.Pricelist === category)
                          )
                        : selectedCategory[0]
                        ? categories.find(
                            (c) => c.Pricelist === selectedCategory[0]
                          ) || null
                        : null
                    }
                    onChange={handleCategoryChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Pricelist"
                        placeholder="Search..."
                        fullWidth
                        error={!!errors.pricelist}
                      />
                    )}
                    renderTags={
                      (selected, getTagProps) =>
                        priceListMulti
                          ? [
                              ...selected
                                .slice(0, 1)
                                .map((option, index) => (
                                  <Chip
                                    key={option.Pricelist}
                                    label={option.Pricelist}
                                    {...getTagProps({ index })}
                                  />
                                )),
                              selected.length > 1 ? (
                                <Chip
                                  key="more"
                                  label={`+${selected.length - 1} more`}
                                  sx={{
                                    backgroundColor: "#28B7A6",
                                    color: "white",
                                  }}
                                />
                              ) : null,
                            ]
                          : null // No tags for single-select
                    }
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        {channelMulti && (
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            checked={
                              option.Pricelist === "Select All"
                                ? selectedCategory.length === categories.length
                                : selected
                            }
                            sx={{
                              color: "#149485",
                              "&.Mui-checked": {
                                color: "#149485",
                              },
                            }}
                          />
                        )}
                        {option.Pricelist}
                      </li>
                    )}
                    sx={{
                      "& .MuiAutocomplete-tag": {
                        backgroundColor: "#28B7A6",
                        color: "white",
                      },
                    }}
                  />
                  {errors.pricelist && (
                    <FormHelperText
                      sx={{
                        color: "#FF0000 !important",
                        marginTop: "4px !important",
                        marginLeft: "0",
                        marginRight: "0",
                      }}
                    >
                      {errors.pricelist}*
                    </FormHelperText>
                  )}
                </FormControl>
                <Grid item xs={6} sx={{ width: "100%" }}>
                  <FormControl
                    style={{ minWidth: "380px", width: "100%", flexGrow: 1 }}
                    error={!!errors.product}
                  >
                    <Autocomplete
                      options={productNames.map(
                        ({ Product_Name }) => Product_Name
                      )}
                      value={selectedProduct}
                      onChange={handleProductChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Product"
                          variant="outlined"
                          fullWidth
                          error={!!errors.product}
                        />
                      )}
                      sx={{ width: "100%" }}
                    />
                    {errors.product && (
                      <FormHelperText
                        sx={{
                          color: "#FF0000 !important",
                          marginTop: "4px !important",
                          marginLeft: "0",
                          marginRight: "0",
                        }}
                      >
                        {errors.product}*
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
                {/* date */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "20px",
                    marginTop: "20px",
                    marginBottom: "15px",
                    marginLeft: "16px",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <DatePicker
                      label="Start Date"
                      sx={{ width: "100%" }}
                      value={
                        modalformData.schemeStartDate
                          ? dayjs(modalformData.schemeStartDate)
                          : null
                      }
                      onChange={(newValue) => {
                        modalsetFormData((prevData) => ({
                          ...prevData,
                          schemeStartDate: newValue
                            ? newValue.format("YYYY-MM-DD")
                            : "",
                        }));
                        if (newValue) {
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            schemeStartDate: "",
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          margin="normal"
                          error={Boolean(errors.schemeStartDate)}
                          helperText={errors.schemeStartDate}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderColor: errors.schemeStartDate
                                ? "red"
                                : undefined,
                            },
                          }}
                        />
                      )}
                      disablePast={true}
                      shouldDisableDate={
                        shouldDisableDate ? disableDateCondition : undefined
                      }
                    />
                    {errors.schemeStartDate && (
                      <FormHelperText
                        sx={{
                          color: "#FF0000",
                          marginTop: "4px",
                        }}
                      >
                        {errors.schemeStartDate}*
                      </FormHelperText>
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <DatePicker
                      label="End Date"
                      sx={{ width: "100%" }}
                      value={
                        modalformData.schemeEndDate
                          ? dayjs(modalformData.schemeEndDate)
                          : null
                      }
                      onChange={(newValue) => {
                        modalsetFormData((prevData) => ({
                          ...prevData,
                          schemeEndDate: newValue
                            ? newValue.format("YYYY-MM-DD")
                            : "",
                        }));
                        if (newValue) {
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            schemeEndDate: "",
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth margin="normal" />
                      )}
                      disablePast={true}
                      shouldDisableDate={
                        shouldDisableDate ? disableDateCondition : undefined
                      }
                    />
                    {errors.schemeEndDate && (
                      <FormHelperText
                        sx={{
                          color: "#FF0000",
                          marginTop: "4px",
                        }}
                      >
                        {errors.schemeEndDate}*
                      </FormHelperText>
                    )}
                  </Box>
                </Box>
              </LocalizationProvider>
                {/* MRP & PTR */}
              <Grid item xs={12} sx={{ display: "flex", gap: "20px" }}>
                <Grid item xs={6} sx={{ width: "100%" }}>
                  <TextField
                    fullWidth
                    sx={{ width: "100%" }}
                    label="MRP"
                    name="MRP"
                    value={modalformData.MRP}
                    onChange={(e) => {
                      const value = e.target.value;
                      modalsetFormData((prevData) => ({
                        ...prevData,
                        MRP: value,
                      }));
                      if (value) {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          MRP: "",
                        }));
                      }
                    }}
                    error={Boolean(errors.MRP)}
                  />
                  {errors.MRP && (
                    <FormHelperText
                      sx={{
                        color: "#FF0000",
                        marginTop: "4px",
                      }}
                    >
                      {errors.MRP}*
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={6} sx={{ width: "100%" }}>
                  <TextField
                    fullWidth
                    sx={{ width: "100%" }}
                    label="PTR"
                    name="PTR"
                    value={modalformData.PTR}
                    onChange={(e) => {
                      const value = e.target.value;
                      modalsetFormData((prevData) => ({
                        ...prevData,
                        PTR: value,
                      }));
                      if (value) {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          PTR: "",
                        }));
                      }
                    }}
                    error={Boolean(errors.PTR)}
                  />
                  {errors.PTR && (
                    <FormHelperText
                      sx={{
                        color: "#FF0000",
                        marginTop: "4px",
                      }}
                    >
                      {errors.PTR}*
                    </FormHelperText>
                  )}
                </Grid>
              </Grid>
                {/* QTY */}
                
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={qtyLabel}
                  name="Qty"
                  style={{ minWidth: "370px", width: "48%", flexGrow: 1 }}
                  value={modalformData.Qty}
                  onChange={(e) => {
                    const value = e.target.value;
                    modalsetFormData((prevData) => ({
                      ...prevData,
                      Qty: value,
                    }));
                    if (value) {
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        Qty: "",
                      }));
                    }
                  }}
                  error={Boolean(errors.Qty)}
                />
                {errors.Qty && (
                  <FormHelperText
                    sx={{
                      color: "#FF0000",
                      marginTop: "4px",
                    }}
                  >
                    {errors.Qty}*
                  </FormHelperText>
                )}
              </Grid>
            </Grid>
          </Box>
        </Box>
      </div>
    </>
  );

  const actionButtons = (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        style={{
          backgroundColor: "#16a695",
          color: "white",
          marginRight: "8px",
        }}
      >
        Update New product
      </Button>

      <Button
        variant="outlined"
        onClick={ () =>{
          handleClose()
          resetForm()
        } }
        style={{ color: "#16a695", borderColor: "#16a695" }}
      >
        Cancel
      </Button>
    </>
  );

  return (
    <ModalComp
      open={isModalOpen}
      // setCustomOpenModal={setCustomOpenModal}
      handleClose={handleClose}
      title={modalTitle}
      modalContent={modalContent}
      modelButtons={actionButtons}
      // onSave={handleSave}
      themeStyles={{
        boxStyle: {
          width: "820px",
          height: "fit-content",
          margin: "auto",
          marginTop: "80px",
        },
        titleStyle: {
          color: "#fff",
          backgroundColor: "#16a695",
          padding: "20px",
          position: "sticky",
          top: 0,
          zIndex: 10,
        },
        fieldStyle: { width: "100%", marginTop: "20px" },
      }}
    />
  );
};

export default AddNewProductModal;
